var LeadStatusIdConfigDEV = {
    individualEntityTypeObj: {
        id: 55,
        name: "INDIVIDUAL",
    },
    nonIndividualEntityTypeObj: {
        id: 56,
        name: "NON INDIVIDUAL",
    },
    interestedBucketStatusConfigObj: {
        id: 2,
        name: "Interested",
    },
    saathiLeadSource: "SAATHI",
    interestedInteractionStatusId: "2",
    followupInteractionStatusId: "6",
    followupSubInteractionStatusId: "3",
    notInterestedInteractionStatusId: "3",
    completedInteractionStatusId: "4",
    notCompletedInteractionStatusId: "5",
    convertedInteractionSubStatusId: "1",
    investmentProductIdObj: {
        id: 220,
        name: "Investment & Trading",
    },
    notConvertedInteractionSubStatusId: "2",
    bucketRegisterationProduct: [2, 5],
    partnerRegistrationCategoryId: 409,
    clientRegistrationCategoryId: 349,
    accquisitionProductId: [5],
    accquisitionProductIdObj: { id: 5, name: "Acquisition" },
    partnerProductIdObj: { id: 78, name: "Partner" },
    sourceIdObject: { id: 31, name: "PARTNER" },
    openStatusIdForLeadFilter: 1,
    inProcessStatusIdForLeadFilter: 2,
    convertedStatusIdForLeadFilter: 3,
    nonConvertedStatusIdForLeadFilter: 4,
    wonConvertedStatusIdForLead: "12",
    lostNotConveretdStatusIdForLead: "13",
    expiredNotConvertedStatusIdForLead: "40",
    responseSubCategoryId: "929",
    otherProductFeedbackId: 9,
    registrationProductId: 77,
    partnerProdctId: 78,
    employeeSourceId: "7",
    dsaSourceId: "1",
    clientSourceId: "6",
    partnerSourceId: "31",
    productBucketId: "2",
    serviceBucketId: "1",
    engagementBucketId: "3",
    acquisitionBucketId: "5",
    requlatoryBucketId: { id: 6, name: "Regulatory" },
    notCompletedStatus: { id: 5, name: "Not Completed" },
    leadSource: ["", "BULLPEN", "DIY", "SALESJOURNEY"],
    customertype: "Lead",
    parentId: -1,
    viewType: "CurrentApprover",
    openStatusIdObject: {
        id: 1,
        name: "Open",
    },
    inProcessStatusIdObject: {
        id: 2,
        name: "In Process",
    },
    convertedStatusIdObject: {
        id: 3,
        name: "Converted",
    },
    notConvertedStatusIdObject: {
        id: 4,
        name: "Not Converted",
    },
    selfTeamObject: {
        id: 1,
        name: "Self",
    },
    teamTypeObject: {
        id: 2,
        name: "Team",
    },
    hierarchyTypeObject: {
        id: 0,
        name: "Hierarchy",
    },
    leadOwnerFilterSourceObj: { id: 1, name: "Lead Owner" },
    primaryOwnerFilterSource: { id: 2, name: "Primary Owner" },
    hotDays: 30,
    warmDays: 60,
    productFeedbackOtherId: 9,
    ApiKey: "Yh2k7QSu4l8CZg5p6X3Pna9",
    SalesSourceName: "SalesJourney",
    CredCategoryObject: {
        id: 360,
        name: "CRED",
    },
    EpCategoryObject: {
        id: 358,
        name: "EP",
    },
    ApCategoryObject: {
        id: 359,
        name: "AP",
    },
    notInterestedSubStatusId: 3,
    nri: {
        name: "NRI",
        id: 2,
    },
    nonNri: {
        name: "NONNRI",
        id: 1,
    },
    countryName: "India",
    countryShortCode: "IN",
    countryCode: "91",
    clientAcquisitionId: "77",
    clientAcquisitionName: "Client Acquisition",
    investmentCategoryName: "Investment",
};
var LeadStatusIdConfigUAT = {
    individualEntityTypeObj: {
        id: 55,
        name: "INDIVIDUAL",
    },
    nonIndividualEntityTypeObj: {
        id: 56,
        name: "NON INDIVIDUAL",
    },
    interestedBucketStatusConfigObj: {
        id: 2,
        name: "Interested",
    },
    investmentProductIdObj: {
        id: 220,
        name: "Investment & Trading",
    },
    saathiLeadSource: "SAATHI",
    interestedInteractionStatusId: "2",
    partnerRegistrationCategoryId: 409,
    clientRegistrationCategoryId: 349,
    followupInteractionStatusId: "6",
    followupSubInteractionStatusId: "3",
    notInterestedInteractionStatusId: "3",
    completedInteractionStatusId: "4",
    notCompletedInteractionStatusId: "5",
    convertedInteractionSubStatusId: "1",
    notConvertedInteractionSubStatusId: "2",
    notCompletedStatus: { id: 5, name: "Not Completed" },
    bucketRegisterationProduct: [2, 5],
    responseSubCategoryId: "929",
    accquisitionProductId: [5],
    accquisitionProductIdObj: { id: 5, name: "Acquisition" },
    partnerProductIdObj: { id: 78, name: "Partner" },
    sourceIdObject: { id: 31, name: "PARTNER" },
    openStatusIdForLeadFilter: 1,
    inProcessStatusIdForLeadFilter: 2,
    convertedStatusIdForLeadFilter: 3,
    nonConvertedStatusIdForLeadFilter: 4,
    otherProductFeedbackId: 9,
    registrationProductId: 77,
    partnerProdctId: 78,
    wonConvertedStatusIdForLead: "12",
    lostNotConveretdStatusIdForLead: "13",
    expiredNotConvertedStatusIdForLead: "40",
    employeeSourceId: "7",
    dsaSourceId: "1",
    clientSourceId: "6",
    partnerSourceId: "31",
    productBucketId: "2",
    serviceBucketId: "1",
    engagementBucketId: "3",
    acquisitionBucketId: "5",
    leadSource: ["", "BULLPEN", "DIY", "SALESJOURNEY"],
    customertype: "Lead",
    parentId: -1,
    viewType: "CurrentApprover",
    openStatusIdObject: {
        id: 1,
        name: "Open",
    },
    inProcessStatusIdObject: {
        id: 2,
        name: "In Process",
    },
    convertedStatusIdObject: {
        id: 3,
        name: "Converted",
    },
    notConvertedStatusIdObject: {
        id: 4,
        name: "Not Converted",
    },
    selfTeamObject: {
        id: 1,
        name: "Self",
    },
    teamTypeObject: {
        id: 2,
        name: "Team",
    },
    hierarchyTypeObject: {
        id: 0,
        name: "Hierarchy",
    },
    requlatoryBucketId: { id: 6, name: "Regulatory" },
    leadOwnerFilterSourceObj: { id: 1, name: "Lead Owner" },
    primaryOwnerFilterSource: { id: 2, name: "Primary Owner" },
    hotDays: 30,
    warmDays: 60,
    productFeedbackOtherId: 9,
    ApiKey: "Yh2k7QSu4l8CZg5p6X3Pna9",
    SalesSourceName: "SalesJourney",
    CredCategoryObject: {
        id: 360,
        name: "CRED",
    },
    EpCategoryObject: {
        id: 358,
        name: "EP",
    },
    ApCategoryObject: {
        id: 359,
        name: "AP",
    },
    notInterestedSubStatusId: 3,
    nri: {
        name: "NRI",
        id: 2,
    },
    nonNri: {
        name: "NONNRI",
        id: 1,
    },
    countryName: "India",
    countryShortCode: "IN",
    countryCode: "91",
    clientAcquisitionId: "77",
    clientAcquisitionName: "Client Acquisition",
    investmentCategoryName: "Investment",
};
var LeadStatusIdConfigCUG = {
    individualEntityTypeObj: {
        id: 55,
        name: "INDIVIDUAL",
    },
    nonIndividualEntityTypeObj: {
        id: 56,
        name: "NON INDIVIDUAL",
    },
    interestedBucketStatusConfigObj: {
        id: 2,
        name: "Interested",
    },
    investmentProductIdObj: {
        id: 220,
        name: "Investment & Trading",
    },
    saathiLeadSource: "SAATHI",
    interestedInteractionStatusId: "2",
    followupInteractionStatusId: "6",
    partnerRegistrationCategoryId: 409,
    clientRegistrationCategoryId: 349,
    followupSubInteractionStatusId: "3",
    notInterestedInteractionStatusId: "3",
    completedInteractionStatusId: "4",
    notCompletedInteractionStatusId: "5",
    responseSubCategoryId: "929",
    convertedInteractionSubStatusId: "1",
    notConvertedInteractionSubStatusId: "2",
    otherProductFeedbackId: 9,
    bucketRegisterationProduct: [2, 5],
    accquisitionProductId: [5],
    accquisitionProductIdObj: { id: 5, name: "Acquisition" },
    notCompletedStatus: { id: 5, name: "Not Completed" },
    partnerProductIdObj: { id: 78, name: "Partner" },
    sourceIdObject: { id: 31, name: "PARTNER" },
    openStatusIdForLeadFilter: 1,
    inProcessStatusIdForLeadFilter: 2,
    convertedStatusIdForLeadFilter: 3,
    registrationProductId: 77,
    partnerProdctId: 78,
    nonConvertedStatusIdForLeadFilter: 4,
    wonConvertedStatusIdForLead: "12",
    lostNotConveretdStatusIdForLead: "13",
    expiredNotConvertedStatusIdForLead: "40",
    employeeSourceId: "7",
    dsaSourceId: "1",
    clientSourceId: "6",
    partnerSourceId: "31",
    productBucketId: "2",
    serviceBucketId: "1",
    engagementBucketId: "3",
    acquisitionBucketId: "5",
    leadSource: ["", "BULLPEN", "DIY", "SALESJOURNEY"],
    customertype: "Lead",
    parentId: -1,
    viewType: "CurrentApprover",
    openStatusIdObject: {
        id: 1,
        name: "Open",
    },
    inProcessStatusIdObject: {
        id: 2,
        name: "In Process",
    },
    convertedStatusIdObject: {
        id: 3,
        name: "Converted",
    },
    notConvertedStatusIdObject: {
        id: 4,
        name: "Not Converted",
    },
    selfTeamObject: {
        id: 1,
        name: "Self",
    },
    teamTypeObject: {
        id: 2,
        name: "Team",
    },
    hierarchyTypeObject: {
        id: 0,
        name: "Hierarchy",
    },
    requlatoryBucketId: { id: 6, name: "Regulatory" },
    leadOwnerFilterSourceObj: { id: 1, name: "Lead Owner" },
    primaryOwnerFilterSource: { id: 2, name: "Primary Owner" },
    hotDays: 30,
    warmDays: 60,
    productFeedbackOtherId: 9,
    ApiKey: "Yh2k7QSu4l8CZg5p6X3Pna9",
    SalesSourceName: "SalesJourney",
    CredCategoryObject: {
        id: 360,
        name: "CRED",
    },
    EpCategoryObject: {
        id: 358,
        name: "EP",
    },
    ApCategoryObject: {
        id: 359,
        name: "AP",
    },
    notInterestedSubStatusId: 3,
    nri: {
        name: "NRI",
        id: 2,
    },
    nonNri: {
        name: "NONNRI",
        id: 1,
    },
    countryName: "India",
    countryShortCode: "IN",
    countryCode: "91",
    clientAcquisitionId: "77",
    clientAcquisitionName: "Client Acquisition",
    investmentCategoryName: "Investment",
};
var LeadStatusIdConfigPROD = {
    individualEntityTypeObj: {
        id: 55,
        name: "INDIVIDUAL",
    },
    nonIndividualEntityTypeObj: {
        id: 56,
        name: "NON INDIVIDUAL",
    },
    interestedBucketStatusConfigObj: {
        id: 2,
        name: "Interested",
    },
    investmentProductIdObj: {
        id: 220,
        name: "Investment & Trading",
    },
    saathiLeadSource: "SAATHI",
    interestedInteractionStatusId: "2",
    followupInteractionStatusId: "6",
    partnerRegistrationCategoryId: 409,
    clientRegistrationCategoryId: 349,
    followupSubInteractionStatusId: "3",
    notInterestedInteractionStatusId: "3",
    completedInteractionStatusId: "4",
    notCompletedInteractionStatusId: "5",
    responseSubCategoryId: "929",
    convertedInteractionSubStatusId: "1",
    notConvertedInteractionSubStatusId: "2",
    bucketRegisterationProduct: [2, 5],
    accquisitionProductId: [5],
    accquisitionProductIdObj: { id: 5, name: "Acquisition" },
    notCompletedStatus: { id: 5, name: "Not Completed" },
    partnerProductIdObj: { id: 78, name: "Partner" },
    sourceIdObject: { id: 31, name: "PARTNER" },
    openStatusIdForLeadFilter: 1,
    inProcessStatusIdForLeadFilter: 2,
    registrationProductId: 77,
    partnerProdctId: 78,
    convertedStatusIdForLeadFilter: 3,
    nonConvertedStatusIdForLeadFilter: 4,
    otherProductFeedbackId: 9,
    wonConvertedStatusIdForLead: "12",
    lostNotConveretdStatusIdForLead: "13",
    expiredNotConvertedStatusIdForLead: "40",
    employeeSourceId: "7",
    dsaSourceId: "1",
    clientSourceId: "6",
    partnerSourceId: "31",
    productBucketId: "2",
    serviceBucketId: "1",
    engagementBucketId: "3",
    acquisitionBucketId: "5",
    leadSource: ["", "BULLPEN", "DIY", "SALESJOURNEY"],
    customertype: "Lead",
    parentId: -1,
    viewType: "CurrentApprover",
    openStatusIdObject: {
        id: 1,
        name: "Open",
    },
    inProcessStatusIdObject: {
        id: 2,
        name: "In Process",
    },
    convertedStatusIdObject: {
        id: 3,
        name: "Converted",
    },
    notConvertedStatusIdObject: {
        id: 4,
        name: "Not Converted",
    },
    selfTeamObject: {
        id: 1,
        name: "Self",
    },
    teamTypeObject: {
        id: 2,
        name: "Team",
    },
    hierarchyTypeObject: {
        id: 0,
        name: "Hierarchy",
    },
    requlatoryBucketId: { id: 6, name: "Regulatory" },
    leadOwnerFilterSourceObj: { id: 1, name: "Lead Owner" },
    primaryOwnerFilterSource: { id: 2, name: "Primary Owner" },
    hotDays: 30,
    warmDays: 60,
    productFeedbackOtherId: 9,
    ApiKey: "Yh2k7QSu4l8CZg5p6X3Pna9",
    SalesSourceName: "SalesJourney",
    CredCategoryObject: {
        id: 360,
        name: "CRED",
    },
    EpCategoryObject: {
        id: 358,
        name: "EP",
    },
    ApCategoryObject: {
        id: 359,
        name: "AP",
    },
    notInterestedSubStatusId: 3,
    nri: {
        name: "NRI",
        id: 2,
    },
    nonNri: {
        name: "NONNRI",
        id: 1,
    },
    countryName: "India",
    countryShortCode: "IN",
    countryCode: "91",
    clientAcquisitionId: "77",
    clientAcquisitionName: "Client Acquisition",
    investmentCategoryName: "Investment",
};
export var leadStatusConfig = process.env.NODE_ENV === "production"
    ? LeadStatusIdConfigPROD
    : process.env.NODE_ENV === "cug"
        ? LeadStatusIdConfigCUG
        : process.env.NODE_ENV === "uat"
            ? LeadStatusIdConfigUAT
            : LeadStatusIdConfigDEV;
